import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import dayjs from "dayjs";

export const salesApi = createApi({
    reducerPath: 'salesApi',
    tagTypes: ['sales', 'salesStatistics'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getSales: build.query({
            query: (data) => ({
                url: api.sales.getSales(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id, queryArgs.start_date];
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['sales']
        }),
        getSaleById: build.query({
            query: ({ id, ...data }) => ({
                url: api.sales.getSaleById(id),
                method: 'GET',
                params: data,
            }),
        }),
        getSalesStatistics: build.query({
            query: (data) => ({
                url: api.sales.getSalesStatistics(),
                method: 'GET',
                params: data
            }),
            providesTags: ['salesStatistics']
        }),
        createSale: build.mutation({
            query: (data) => ({
                url: api.sales.createSale(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        salesApi.util.updateQueryData('getSales', {
                            ...patch,
                            start_date: dayjs(patch.date).format('YYYY-MM-DD'),
                        }, (draft) => {
                            draft.unshift(data)
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
            invalidatesTags: ['salesStatistics', 'sales'],
        }),
        refundSale: build.mutation({
            query: ({ id }) => ({
                url: api.sales.refundSale(id),
                method: 'DELETE',
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        salesApi.util.updateQueryData('getSales', patch, (draft) => {
                            const itemIndex = draft?.findIndex(item => item.id === patch.id)
                            if (itemIndex !== -1) {
                                draft[itemIndex] = data
                            }
                        })
                    );
                } catch (e) {
                    console.error('Refund failed:', e)
                }
            },
            invalidatesTags: ['sales'],
        }),
    })
})

export const { useRefundSaleMutation, useLazyGetSalesStatisticsQuery, useGetSalesStatisticsQuery } = salesApi